import { ColDef } from '@ag-grid-community/core';
import { OrderSide, TransactionTypeChar } from '@tassat/common-definitions';
import { Asset } from '@tassat/fred-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import { formatAsAsset, formatEpochDate } from '@tassat/utility';
import { capitalizeFirstLetter } from '@tassat/utility/src/stringHelpers/helpers';

import { getTransactionTypeString } from 'Lib/transactionTypeHelper';

export const getColumnDefs = (transactionFilter: 'pending' | 'recent'): Array<ColDef> => ([
    {
        field: 'TransType',
        headerName: 'Transaction Type',
        valueFormatter: ({ data }: { data: TransactionHistoryRecord }) => {
            const tranType = getTransactionTypeString(data);

            return capitalizeFirstLetter(tranType);
        },
        valueGetter: () => ({ isAdmin: false }),
        menuTabs: []
    },
    {
        field: 'Ticker',
        cellRenderer: 'transactionAsset',
        headerName: 'Asset',
        menuTabs: []
    },
    {
        field: 'SenderAccountName',
        cellRenderer: 'accountLink',
        cellRendererParams: { state: { tableFilters: { IsCompleted: transactionFilter === 'recent' }}},
        headerName: 'Account',
        menuTabs: []
    },
    {
        field: 'Amount',
        headerName: 'Amount',
        valueFormatter: (
            { data, context }:
            {
                data: TransactionHistoryRecord;
                context: { assets: Record<string, Asset> };
            }
        ) => {
            let showAsset = true;

            if (data.type === TransactionTypeChar.order &&
                (data.OrderSide === OrderSide.BUY ||
                    data.OrderSide === OrderSide.SUBSCRIPTION)) {
                showAsset = false;
            }

            if (data.type === TransactionTypeChar.deposit || data.type === TransactionTypeChar.withdrawal) {
                showAsset = false;
            }
            if (
                (data.type === TransactionTypeChar.send || data.type === TransactionTypeChar.receive) &&
                data.Ticker === data.CurCode
            ) {
                showAsset = false;
            }

            const asset = Object.values(context?.assets || {})
                .find((asset: Asset) => {
                    if (data.type === TransactionTypeChar.order &&
                        (data.OrderSide === OrderSide.BUY ||
                            data.OrderSide === OrderSide.SUBSCRIPTION)) {
                        return data.CurCode === asset.Ticker;
                    } else return asset.Ticker === data.Ticker;
                });

            if (asset && showAsset) {
                return formatAsAsset(data.AssetQuantity, asset, 'ticker', undefined, true);
            } else if (asset && !showAsset) {
                return formatAsAsset(data.FiatAmount || data.AssetQuantity, asset, 'symbol');
            } else return '-';
        },
        menuTabs: []
    },
    {
        field: 'AuditTime',
        headerName: 'Date/Time',
        valueFormatter: ({ value }) => `${formatEpochDate(value, 'MMM DD YYYY')} at ${formatEpochDate(value, 'HH:mm:ss')}`,
        menuTabs: []
    }
]);